import styled from 'styled-components/macro'
import { rem, color } from '../../utils/styles'

import SelectLabel from '../FormFields/SelectField/SelectLabel'

const InfoBox = styled.article`
  padding: ${rem(40)} ${rem(40)};
  border-radius: ${rem(10)};
  background-color: ${color('light')};

  ${SelectLabel} {
    background-color: ${color('light')};
  }
`

export default InfoBox
